/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Link_Editor_DeleteInputs */

const en_link_editor_delete = /** @type {(inputs: Link_Editor_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Link`)
};

const es_link_editor_delete = /** @type {(inputs: Link_Editor_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar Enlace`)
};

const fr_link_editor_delete = /** @type {(inputs: Link_Editor_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le lien`)
};

const de_link_editor_delete = /** @type {(inputs: Link_Editor_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link löschen`)
};

/** @type {(inputs: Link_Editor_DeleteInputs) => LocalizedString} */
const ja_link_editor_delete = en_link_editor_delete;

/** @type {(inputs: Link_Editor_DeleteInputs) => LocalizedString} */
const zh_link_editor_delete = en_link_editor_delete;

/** @type {(inputs: Link_Editor_DeleteInputs) => LocalizedString} */
const ar_link_editor_delete = en_link_editor_delete;

/** @type {(inputs: Link_Editor_DeleteInputs) => LocalizedString} */
const id_link_editor_delete = en_link_editor_delete;

/** @type {(inputs: Link_Editor_DeleteInputs) => LocalizedString} */
const it_link_editor_delete = en_link_editor_delete;

/** @type {(inputs: Link_Editor_DeleteInputs) => LocalizedString} */
const ru_link_editor_delete = en_link_editor_delete;

/** @type {(inputs: Link_Editor_DeleteInputs) => LocalizedString} */
const pt_link_editor_delete = en_link_editor_delete;

/** @type {(inputs: Link_Editor_DeleteInputs) => LocalizedString} */
const ko_link_editor_delete = en_link_editor_delete;

/**
* | output |
* | --- |
* | "Delete Link" |
*
* @param {Link_Editor_DeleteInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const link_editor_delete = /** @type {((inputs?: Link_Editor_DeleteInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Editor_DeleteInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_link_editor_delete(inputs)
	if (locale === "es") return es_link_editor_delete(inputs)
	if (locale === "fr") return fr_link_editor_delete(inputs)
	if (locale === "de") return de_link_editor_delete(inputs)
	if (locale === "ja") return ja_link_editor_delete(inputs)
	if (locale === "zh") return zh_link_editor_delete(inputs)
	if (locale === "ar") return ar_link_editor_delete(inputs)
	if (locale === "id") return id_link_editor_delete(inputs)
	if (locale === "it") return it_link_editor_delete(inputs)
	if (locale === "ru") return ru_link_editor_delete(inputs)
	if (locale === "pt") return pt_link_editor_delete(inputs)
	return ko_link_editor_delete(inputs)
});